var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apps" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: { select: _vm.handleSelect },
        },
        _vm._l(_vm.lacApps, function (item, index) {
          return _c(
            "el-menu-item",
            {
              key: index,
              staticStyle: { "max-width": "100px" },
              style:
                _vm.activeIndex === item.id
                  ? "background:rgba(" +
                    _vm.colorConversionRgb(_vm.topNavSetBg) +
                    ",.15); border-bottom:2px solid rgba(" +
                    _vm.colorConversionRgb(_vm.topNavSetBg) +
                    ",1); color:rgba(" +
                    _vm.colorConversionRgb(_vm.topNavSetTextColor) +
                    ",1)"
                  : "color:rgba(" +
                    _vm.colorConversionRgb(_vm.topNavTextColor) +
                    ",1)",
              attrs: { index: item.id },
            },
            [_vm._v("\n      " + _vm._s(item.appName) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }